export const PRICING_VERSION_KEY = "pricingPopupVisualVersion";
export const PRICING_VERSION_V1 = "v1";
export const PRICING_VERSION_V2 = "v2";

// The prototype selector is disabled, so V1 remains authoritative.
export const readPricingVersion = () => PRICING_VERSION_V1;

export const writePricingVersion = (version) => {
  const next = version === PRICING_VERSION_V2 ? PRICING_VERSION_V2 : PRICING_VERSION_V1;
  try {
    window.localStorage.setItem(PRICING_VERSION_KEY, next);
  } catch {
    // Ignore storage access errors.
  }
  return next;
};
